module.exports = __webpack_public_path__ + "img/framenew_box18.549aec65.jpg";